import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { unarchiveApplicationFailed, unarchiveApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* unarchiveApplication(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/${action.payload}/unarchive`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(unarchiveApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(unarchiveApplicationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(unarchiveApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
